/* Wanelo Vibe — shared interactions: favourite toggle, add-to-cart (AJAX), night mode, filter accordions. */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    // Избранное: сердечко ЗАПОМИНАЕТ товар (раньше меняло только вид и ничего не
    // сохраняло, из-за чего кнопка обманывала покупателя). Храним хэндлы в localStorage.
    window.VIBE_FAVS = {
      list: function(){ try{ return JSON.parse(localStorage.getItem('vibe_favs')||'[]'); }catch(e){ return []; } },
      has: function(h){ return this.list().indexOf(h) !== -1; },
      ids: function(){ try{ return JSON.parse(localStorage.getItem('vibe_favs_ids')||'{}'); }catch(e){ return {}; } },
      rememberId: function(h, id){
        if(!h || !id) return;
        var m = this.ids(); m[h] = String(id);
        try{ localStorage.setItem('vibe_favs_ids', JSON.stringify(m)); }catch(e){}
      },
      toggle: function(h, id){
        var a = this.list(), i = a.indexOf(h);
        if(i === -1){ a.push(h); } else { a.splice(i,1); }
        try{ localStorage.setItem('vibe_favs', JSON.stringify(a)); }catch(e){}
        this.rememberId(h, id);
        document.dispatchEvent(new CustomEvent('vibe:favs', {detail:{list:a, handle:h, added:i===-1}}));
        if(window.VIBE_FAVS_SYNC) window.VIBE_FAVS_SYNC.onToggle(h, i === -1);
        return i === -1;
      }
    };
    function favHandle(el){
      var h = el.getAttribute('data-fav');
      if(h && h !== 'true' && h !== '') return h;
      var a = el.closest('a[href*="/products/"]') || document.querySelector('link[rel=canonical]');
      var href = a ? (a.getAttribute('href') || a.href || '') : '';
      var m = href.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }
    // Вид сердечек + счётчик в хедере. Перерисовка идемпотентна — зовём сколько угодно.
    function favPaint(){
      var n = window.VIBE_FAVS.list().length;
      document.querySelectorAll('[data-fav]').forEach(function(b){
        var h = favHandle(b), on = !!(h && window.VIBE_FAVS.has(h));
        b.classList.toggle('on', on);
        var sv = b.querySelector('svg'); if(sv) sv.setAttribute('fill', on ? 'var(--neon-mag)' : 'none');
      });
      document.querySelectorAll('[data-fav-count]').forEach(function(c){
        c.textContent = n > 99 ? '99+' : String(n); c.hidden = !n;
      });
    }
    // Сердечки для карточек умной ленты: .product-card строит personalized-feed.js,
    // его разметку/контракт не трогаем — кнопку довешиваем снаружи.
    function favDecorate(){
      document.querySelectorAll('.product-card').forEach(function(card){
        if(card.querySelector('[data-fav]')) return;
        var a = card.querySelector('a[href*="/products/"]'); if(!a) return;
        var m = (a.getAttribute('href')||'').match(/\/products\/([^/?#]+)/); if(!m) return;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'fpcard__fav'; b.setAttribute('data-fav', m[1]);
        b.setAttribute('aria-label', 'Save');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
        card.style.position = 'relative';
        card.appendChild(b);
      });
      favPaint();
    }
    // Один делегированный обработчик на документ: живёт для карточек, добавленных
    // бесконечной лентой ПОСЛЕ загрузки, и не дублируется при повторной загрузке
    // vibe.js (страница поиска грузит его дважды — раньше клик срабатывал 2 раза).
    if(!window.__vibeFavsArmed){
      window.__vibeFavsArmed = 1;
      document.addEventListener('click', function(e){
        var b = e.target.closest && e.target.closest('[data-fav]'); if(!b) return;
        e.preventDefault(); e.stopPropagation();
        var h = favHandle(b); if(!h) return;
        window.VIBE_FAVS.toggle(h, b.getAttribute('data-fav-id') || null);
        favPaint();
      }, true);
      document.addEventListener('vibe:favs', favPaint);
      document.addEventListener('shopify:section:load', favDecorate);
      var favPend = 0;
      new MutationObserver(function(){
        if(favPend) return;
        favPend = requestAnimationFrame(function(){ favPend = 0; favDecorate(); });
      }).observe(document.body, {childList:true, subtree:true});
    }
    favDecorate();
    // --- Синк с reco-приложением (/apps/reco/*): тихо спит, пока приложение не
    // установлено (404 -> выкл до конца сессии). После деплоя эти же сердечки
    // становятся кросс-девайс у залогиненных: мерж список с сервера + дозалив
    // локального, каждое сердечко = wishlist-сигнал в профиль умной ленты. ---
    if(!window.VIBE_FAVS_SYNC){
      window.VIBE_FAVS_SYNC = (function(){
        var OK='vibe_reco_ok', LI='vibe_reco_li';
        function g(k){ try{ return sessionStorage.getItem(k); }catch(e){ return '0'; } }
        function st(k,v){ try{ sessionStorage.setItem(k,v); }catch(e){} }
        function anon(){ try{ return localStorage.getItem('reco_anonymous_id') || undefined; }catch(e){ return undefined; } }
        function post(path, body){
          return fetch('/apps/reco/'+path+'?tracking_allowed=1', {method:'POST',
            headers:{'content-type':'application/json'}, body: JSON.stringify(body), keepalive:true});
        }
        function idFor(h){
          var m = window.VIBE_FAVS.ids();
          if(m[h]) return Promise.resolve(m[h]);
          return fetch('/products/'+h+'.js').then(function(r){ return r.ok ? r.json() : null; })
            .then(function(p){ if(!p || !p.id) return null;
              window.VIBE_FAVS.rememberId(h, p.id); return String(p.id); });
        }
        function onToggle(h, added){
          if(g(OK) !== '1') return;
          idFor(h).then(function(id){
            if(!id) return;
            if(g(LI) === '1') post('favorites', added ? {add:[id]} : {remove:[id]}).catch(function(){});
            post('events', {shopDomain: location.host, anonymousId: anon(),
              eventType: added ? 'wishlist_added' : 'wishlist_removed',
              productId: 'gid://shopify/Product/'+id, context: 'wishlist',
              occurredAt: new Date().toISOString(), metadata:{source:'theme'}}).catch(function(){});
          }).catch(function(){});
        }
        if(g(OK) !== '0' && g(OK) !== '1'){
          fetch('/apps/reco/favorites').then(function(r){ if(!r.ok) throw 0; return r.json(); })
            .then(function(d){
              st(OK,'1'); st(LI, d && d.loggedIn ? '1' : '0');
              if(!d || !d.loggedIn) return;
              var local = window.VIBE_FAVS.list(), server = d.favorites || [];
              var sh = server.map(function(f){ return f.handle; }).filter(Boolean);
              var merged = local.slice();
              sh.forEach(function(h){ if(merged.indexOf(h) === -1) merged.push(h); });
              server.forEach(function(f){
                var mm = String(f.productId||'').match(/(\d+)$/);
                if(f.handle && mm) window.VIBE_FAVS.rememberId(f.handle, mm[1]);
              });
              try{ localStorage.setItem('vibe_favs', JSON.stringify(merged)); }catch(e){}
              document.dispatchEvent(new CustomEvent('vibe:favs', {detail:{list:merged}}));
              var toPush = local.filter(function(h){ return sh.indexOf(h) === -1; }).slice(0, 30);
              (function next(){
                var h = toPush.shift(); if(!h) return;
                idFor(h).then(function(id){ if(id) return post('favorites', {add:[id]}); })
                  .then(next).catch(function(){ next(); });
              })();
            }).catch(function(){ st(OK,'0'); });
        }
        return { onToggle: onToggle };
      })();
    }
    // night mode
    var vh=document.querySelector('.vibe-home, .vibe-page');
    document.querySelectorAll('[data-night-toggle]').forEach(function(nt){
      if(vh){ try{ if(localStorage.getItem('vibe_night')==='1') vh.classList.add('night'); }catch(e){} }
      nt.addEventListener('click', function(){ if(!vh) return; vh.classList.toggle('night');
        var on=vh.classList.contains('night');
        document.documentElement.classList.toggle('night-pref', on);
        try{ localStorage.setItem('vibe_night', on?'1':'0'); }catch(e){} });
    });

    // ===== 2026-08-17 ATC feedback (UX walk finding #2): visible toast + guaranteed header badge =====
    // Before: only a 1.6s label swap; badge updated only if it already existed -> new visitors saw nothing.
    window.vibeCartFeedback = function(addedQty){
      try{
        fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
          var n = c && c.item_count ? c.item_count : (addedQty||1);
          var cart = document.querySelector('.fhdr .ficon[href*="cart"], .fhdr a[href="/cart"], a[href="/cart"]');
          if(cart){ var s = cart.querySelector('.cnt'); if(!s){ s=document.createElement('span'); s.className='cnt'; cart.appendChild(s); } s.textContent = n; s.classList.remove('vcart-pulse'); void s.offsetWidth; s.classList.add('vcart-pulse'); }
          var t = document.querySelector('.vcart-toast'); if(t) t.remove();
          t = document.createElement('div'); t.className='vcart-toast'; t.setAttribute('role','status');
          t.innerHTML = '<span class="vcart-toast__ok">✓</span><span>Added to cart</span><a href="/cart">View cart →</a>';
          document.body.appendChild(t); requestAnimationFrame(function(){ t.classList.add('on'); });
          setTimeout(function(){ t.classList.remove('on'); setTimeout(function(){ t.remove(); }, 350); }, 3600);
        }).catch(function(){});
      }catch(e){}
    };

    // стрелка «назад» в крошках: если есть куда вернуться в пределах сайта — назад по
    // истории, иначе поднимаемся на предпоследнюю крошку (родительский раздел), а не на главную
    document.addEventListener('click', function(ev){
      var b = ev.target.closest && ev.target.closest('[data-crumb-back]'); if(!b) return;
      ev.preventDefault();
      var sameSite = document.referrer && document.referrer.indexOf(location.host) !== -1;
      if(sameSite && history.length > 1){ history.back(); return; }
      var links = b.parentNode ? b.parentNode.querySelectorAll('a[href]') : [];
      if(links.length){ location.href = links[links.length-1].getAttribute('href'); }
      else { location.href = '/'; }
    });
    // add to cart (AJAX) — delegated so dynamically-added cards (personalized feed) also work
    document.addEventListener('click', function(ev){
      var b = ev.target.closest && ev.target.closest('[data-add]'); if(!b) return;
      var id=b.getAttribute('data-add'); if(!id || b.classList.contains('added')) return;
      b.classList.add('added'); var old=b.innerHTML; b.textContent='✓ In cart';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
        .then(function(r){return r.json()}).then(function(){ if(window.vibeCartFeedback) window.vibeCartFeedback(1); var c=document.querySelector('.fhdr .ficon .cnt');
          if(c){ c.textContent=(parseInt(c.textContent||'0')+1); } else { var cart=document.querySelector('.fhdr .ficon[href*="cart"]'); if(cart){ var s=document.createElement('span'); s.className='cnt'; s.textContent='1'; cart.appendChild(s); } }
          setTimeout(function(){ b.classList.remove('added'); b.innerHTML=old; },1500); })
        .catch(function(){ b.classList.remove('added'); b.innerHTML=old; });
    });
    // filter group accordions (collection sidebar)
    document.querySelectorAll('.ffg__h').forEach(function(h){
      h.addEventListener('click', function(e){ e.preventDefault(); h.closest('.ffg').classList.toggle('closed'); });
    });
    // mobile filter drawer
    var fside=document.querySelector('.fcat-side');
    document.querySelectorAll('[data-filters-open]').forEach(function(b){ b.addEventListener('click',function(){ if(fside) fside.classList.add('open'); document.body.style.overflow='hidden'; }); });
    document.querySelectorAll('[data-filters-close]').forEach(function(b){ b.addEventListener('click',function(){ if(fside) fside.classList.remove('open'); document.body.style.overflow=''; }); });
    document.addEventListener('click',function(e){ if(fside && fside.classList.contains('open') && !fside.contains(e.target) && !e.target.closest('[data-filters-open]')){ fside.classList.remove('open'); document.body.style.overflow=''; } });

    // product card photo carousel (hover-zones desktop, swipe mobile)
    function initVpc(scope){
      (scope||document).querySelectorAll('[data-vpc]').forEach(function(vpc){
        if(vpc.getAttribute('data-vpc-ready')) return; vpc.setAttribute('data-vpc-ready','1');
        var slides=vpc.querySelectorAll('.vpc__slide'); if(slides.length<2) return;
        var wrap=vpc.closest('.fpcard__img'); var dots=wrap?wrap.querySelectorAll('.vpc__dots i'):[];
        var idx=0, moved=false, loaded=false;
        function loadAll(){ if(loaded)return; loaded=true; slides.forEach(function(s){ var d=s.getAttribute('data-src'); if(d && !s.getAttribute('src')){ s.src=d; } }); }
        function show(i){ i=Math.max(0,Math.min(slides.length-1,i)); if(i===idx)return; slides[idx].classList.remove('on'); slides[i].classList.add('on'); if(dots[idx])dots[idx].classList.remove('on'); if(dots[i])dots[i].classList.add('on'); idx=i; }
        if(wrap){ wrap.addEventListener('mouseenter', loadAll);
          wrap.addEventListener('mousemove',function(e){ var r=wrap.getBoundingClientRect(); if(!r.width) return; show(Math.floor((e.clientX-r.left)/r.width*slides.length)); });
          wrap.addEventListener('mouseleave',function(){ show(0); }); }
        var sx=null;
        // 2026-08-17: direction lock — decide horizontal vs vertical on the first ~8px; horizontal = ours
        // (preventDefault stops the page from scrolling under the finger), vertical = page's. Threshold 30->18px.
        var sy=null, dir=null;
        vpc.addEventListener('touchstart',function(e){ loadAll(); sx=e.touches[0].clientX; sy=e.touches[0].clientY; dir=null; moved=false; },{passive:true});
        vpc.addEventListener('touchmove',function(e){ if(sx===null)return; var dx=e.touches[0].clientX-sx, dy=e.touches[0].clientY-sy;
          if(dir===null){ if(Math.abs(dx)<8 && Math.abs(dy)<8) return; dir=(Math.abs(dx)>Math.abs(dy))?'h':'v'; }
          if(dir==='v') return;
          if(e.cancelable) e.preventDefault();
          if(Math.abs(dx)>18){ show(idx+(dx<0?1:-1)); sx=e.touches[0].clientX; sy=e.touches[0].clientY; moved=true; } },{passive:false});
        vpc.addEventListener('touchend',function(){ sx=null; sy=null; dir=null; });
        if(wrap&&wrap.tagName==="A"){ wrap.addEventListener('click',function(e){ if(moved){ e.preventDefault(); moved=false; } }); }
      });
    }
    initVpc(document);
    // re-init for dynamically-added cards (personalized-feed infinite scroll, theme editor)
    document.addEventListener('shopify:section:load', function(){ initVpc(document); });
    var pfFeed=document.querySelector('.personalized-feed-section');
    if(pfFeed && 'MutationObserver' in window){ var pfDeb=null; new MutationObserver(function(){ if(pfDeb) return; pfDeb=setTimeout(function(){ pfDeb=null; initVpc(pfFeed); }, 120); }).observe(pfFeed, {childList:true, subtree:true}); }

    // ── feed scroll restoration: return to the same spot when coming back from a product ──
    var FEED='.personalized-feed-section';
    function vibeY(){ return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0; }
    document.addEventListener('click', function(e){ var a=e.target.closest(FEED+' a[href*="/products/"]'); if(a){ try{ sessionStorage.setItem('vibe_feed_y', String(Math.round(vibeY()))); sessionStorage.setItem('vibe_feed_t', String(Date.now())); }catch(_){} } }, true);
    function vibeRestoreFeed(){
      if(!document.querySelector(FEED)) return;
      var fy=0, ft=0; try{ fy=parseInt(sessionStorage.getItem('vibe_feed_y')||'0',10); ft=parseInt(sessionStorage.getItem('vibe_feed_t')||'0',10); }catch(_){}
      if(!(fy>120 && (Date.now()-ft)<1800000)) return;
      try{ sessionStorage.removeItem('vibe_feed_y'); sessionStorage.removeItem('vibe_feed_t'); }catch(_){}
      try{ if('scrollRestoration' in history) history.scrollRestoration='manual'; }catch(_){}
      var dl=Date.now()+6000, last=-1, stall=0;
      (function chase(){
        window.scrollTo(0, fy);
        var y=vibeY();
        if(Math.abs(y-fy)<=6 || Date.now()>dl){ setTimeout(function(){ try{ if('scrollRestoration' in history) history.scrollRestoration='auto'; }catch(_){} }, 400); return; }
        if(y===last){ stall++; } else { stall=0; }
        last=y;
        if(stall>4){ window.scrollTo(0, document.body.scrollHeight); } // nudge the feed to reveal/load more
        requestAnimationFrame(chase);
      })();
    }
    vibeRestoreFeed();
    window.addEventListener('pageshow', function(e){ if(e.persisted){ setTimeout(vibeRestoreFeed, 60); } });

    // catalog category dropdown (Catalog button -> categories)
    (function(){
      var btn=document.querySelector('[data-catmenu-toggle]');
      var pop=document.querySelector('[data-catmenu]');
      var bg=document.querySelector('[data-catmenu-bg]');
      if(!btn||!pop) return;
      function isM(){ return window.innerWidth<=760; }
      function place(){ if(isM()){ pop.style.top=''; pop.style.left=''; pop.style.width=''; return; } var r=btn.getBoundingClientRect(); var w=Math.min(640, window.innerWidth-28); var left=Math.min(r.left, window.innerWidth-w-14); if(left<14)left=14; pop.style.width=w+'px'; pop.style.top=(r.bottom+10)+'px'; pop.style.left=left+'px'; }
      function open(){ place(); pop.classList.add('open'); if(bg)bg.classList.add('open'); btn.classList.add('on'); btn.setAttribute('aria-expanded','true'); if(isM()) document.body.style.overflow='hidden'; }
      function close(){ pop.classList.remove('open'); if(bg)bg.classList.remove('open'); btn.classList.remove('on'); btn.setAttribute('aria-expanded','false'); document.body.style.overflow=''; }
      btn.addEventListener('click', function(e){ e.preventDefault(); if(pop.classList.contains('open')) close(); else open(); });
      if(bg) bg.addEventListener('click', close);
      document.querySelectorAll('[data-catmenu-close]').forEach(function(c){ c.addEventListener('click', close); });
      document.addEventListener('click', function(e){ if(!pop.classList.contains('open')) return; if(pop.contains(e.target)||btn.contains(e.target)) return; close(); });
      document.addEventListener('keydown', function(e){ if((e.key==='Escape'||e.key==='Esc') && pop.classList.contains('open')) close(); });
      window.addEventListener('resize', function(){ if(pop.classList.contains('open')) place(); });
    })();
  });
})();

// metafield-section scroll reveal (html.vibe-anim gate -> safe without JS)
(function(){
  if(!('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('vibe-anim');
  function arm(){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('vis'); io.unobserve(e.target); }
    });},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    document.querySelectorAll('.fpsec:not(.vis)').forEach(function(s){
      var r=s.getBoundingClientRect();
      if(r.top<innerHeight*0.92&&r.bottom>0){ s.classList.add('vis'); } else { io.observe(s); }
    });
  }
  if(document.readyState!=='loading') arm(); else document.addEventListener('DOMContentLoaded',arm);
  document.addEventListener('shopify:section:load',arm);
})();
